<template>
  <div>
    <v-toolbar dark app fixed class="toolbar-container">
      <div class="container toolbar-inner-container">
        <div class="img-holder logo-holder" @click="logoutDialog = true">
          <img src="../assets/logo.png" alt="DieselService" />
        </div>
        <div class="ml-0 pl-1 hidden-xs-only">
          <span class="app-name pos-rel">{{ $t('global.appName').replace(/\s/g,'\n') }}<span class="app-ver">{{getVer}}</span></span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click="showUserCard">
          <v-avatar tile>
            <i aria-hidden="true" class="v-icon material-icons">person</i>
          </v-avatar>
          <span class="btn-title">{{ $t('global.yield') }}</span>
        </v-btn>
        <v-btn icon @click="showWorkPlan">
          <v-avatar tile>
            <i aria-hidden="true" class="v-icon material-icons"
              >query_builder</i
            >
          </v-avatar>
          <span class="btn-title">{{ $t('global.schedule') }}</span>
        </v-btn>
        <v-btn icon @click="showCarHistory">
          <v-avatar tile>
            <i aria-hidden="true" class="v-icon material-icons"
              >directions_car</i
            >
          </v-avatar>
          <span class="btn-title">{{ $t('global.history') }}</span>
        </v-btn>
        <v-btn icon to="/doclist">
          <v-avatar tile>
            <i aria-hidden="true" class="v-icon material-icons">content_copy</i>
          </v-avatar>
          <span class="btn-title">{{ $t('global.docList') }}</span>
        </v-btn>
        <v-btn icon @click="stepBack" to="#">
          <v-avatar tile>
            <i aria-hidden="true" class="v-icon material-icons">undo</i>
          </v-avatar>
        </v-btn>
      </div>
    </v-toolbar>
    <user-card ref="userCard" />
    <work-plan ref="workPlan" />
    <car-history ref="carHistory" />

    <v-dialog
            v-model="logoutDialog"
            width="300"
    >
      <v-card class="text-center pt-3">
        <h4>{{ $t('login.logoutConfirm') }}</h4>

        <v-card-actions>
          <v-btn
                  text
                  @click="toHome"
          >
            {{ $t('global.yes') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
                  text
                  @click="logoutDialog = false"
          >
            {{ $t('global.no') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import router from '@/router'
import firebase from 'firebase'
import i18n from '@/plugins/i18n'

export default {
  name: 'Navbar',
  carSearchValue: '',
  props: {
    automobileNumber: String,
  },
  components: {
    'user-card': () => import('./UserCard.vue'),
    'work-plan': () => import('./WorkPlan.vue'),
    'car-history': () => import('./CarHistory.vue'),
  },
  data: function() {
    return {
      logoutDialog: false
    }
  },
  methods: {
    stepBack() {
      let routeName = this.$router.currentRoute.name
      if (routeName === 'DocZN') {
        router.push({ path: '/doclist' })
      } else if (routeName === 'DocList') {
        this.logoutDialog = true
        // router.push({ path: '/' })
      } else {
        router.go(-1)
      }
    },
    signOut() {
      let auth = firebase.auth()
      auth
        .signOut()
        .then(() => {})
        .catch(error => {
          let errorMessage = error.message
          this.$store.dispatch('showSnackMessage', {
            color: 'error',
            text: errorMessage,
          })
        })
    },
    toHome() {
      this.signOut()
      router.push({ path: '/' })
    },
    showUserCard() {
      this.$refs.userCard.show()
    },
    showWorkPlan() {
      this.$refs.workPlan.show()
    },
    showCarHistory() {
      this.$refs.carHistory.show(this.automobileNumber)
    },
    setCarSearchValue(automobileNumber) {
      this.carSearchValue = automobileNumber
    },
  },
  computed: {
    getVer() {
      return process.env.PACKAGE_VERSION
    }
  }
}
</script>

<style scoped lang="scss">
@import '../_scss/mixins';
@import '../_scss/breakpoints';
@import '../_scss/variables';

.app-name {
  font-family: $ffPSr;
  font-size: 16px;
  display: inline;
  white-space: break-spaces;
  position: relative;
  @include sm {
    font-size: 14px;
  }
}
.app-ver {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 6px;
}

.img-holder {
  height: 100%;
  padding: 5px;
  img {
    height: 100%;
    width: auto;
    max-width: none;
  }
}
.toolbar-container {
  @include xs {
    height: 65px;
  }
  /deep/ .v-toolbar__content {
    padding: 0px;
    margin: 0 auto;
    left: 0;
    right: 0;
    justify-content: center;
    min-height: 100%;
    .logo-holder {
      min-height: 60px;
      cursor: pointer;
      @include xs {
        padding: 10px;
      }
    }
    .v-btn {
      display: flex;
      align-items: center;
      position: relative;
      top: -5px;
      .v-btn__content {
        display: flex;
        flex-direction: column;
      }
      .btn-title {
        display: block;
        font-size: 8px;
        position: absolute;
        text-align: center;
        top: calc(100% + 10px);
        @include xs {
          top: calc(100% + 5px);
        }
      }
    }
    .v-btn--icon {
      margin: 6px 12px;
      @include xxs {
        width: 30px;
        height: 30px;
      }
    }
    .v-avatar {
      width: 100% !important;
      height: 100% !important;
      .v-icon {
        font-size: 25px;
      }
      @include xs {
        width: 30px !important;
        height: 30px !important;
      }
    }
  }
}

.toolbar-inner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.v-btn:hover {
  text-decoration: none;
}
</style>
